import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';



@Component({
  selector: 'rental-snack-info-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss']
})
export class SnackBarComponent implements OnInit {

  public readonly type: string;
  public readonly message: string;


  constructor(
    private readonly snackBar: MatSnackBar,
    @Inject(MAT_SNACK_BAR_DATA) private data: SnackBarData
  ) {
    this.type = this.data.type;
    this.message = this.data.message;
  }

  async ngOnInit(): Promise<void> {
    // await (new Audio('assets/audios/snackbar.mp3')).play();
  }

  public closeSnackBar(): void {
    this.snackBar.dismiss();
  }
}

type SnackTypeBar = 'info' | 'success' | 'error'

interface SnackBarData {
  type: SnackTypeBar,
  message: string
}
